export default __webpack_public_path__ + "static/media/targetbanner.eb7d0dd3.jpeg";